import type { ActividadPrograma } from "@/interfaces/actividadPrograma.interface";
import { axiosInstance } from "@retro-ia/shared/axios";
import { useQuery } from "@tanstack/react-query";

export interface ActividadesProgramaResponse {
  data: ActividadPrograma[];
  total: number;
}

export const useActividadesPrograma = (
  page: number,
  limit: number,
  search: string
) => {
  return useQuery<ActividadesProgramaResponse, Error>({
    queryKey: ["actividadesProgramas", page, limit, search],
    queryFn: async () => {
      const response = await axiosInstance.get("/actividades-programa", {
        params: { page, limit, search },
      });
      return response.data;
    },

  });
};
